
import React from "react";
import Layout from "@/components/Layout";
import { ComingSoonSection } from "@/components/dashboard/ComingSoonSection";

export default function Updates() {
  return (
    <Layout>
      <div className="mx-auto max-w-7xl px-6 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Updates & Nieuwe Functies</h1>
          <p className="text-muted-foreground">
            Ontdek hoe we Turnles Planner continu verbeteren met nieuwe functies en updates.
          </p>
        </div>
        <ComingSoonSection />
      </div>
    </Layout>
  );
}
